declare type TypeListener = {
  type: string;
  listeners: Listener[];
};

export class Event {
  public type: string;
  public data: any;

  public constructor(type: string, data: any) {
    this.type = type;
    this.data = data;
  }
}

export abstract class Listener {
  abstract call(data: any): any;
}

class Dispatcher {
  private listeners: TypeListener[] = [];

  public addEventListener(type: string, listener: Listener) {
    let typeListener = this.listeners.find((item) => item.type === type);
    if (!typeListener) {
      typeListener = {
        type: type,
        listeners: [],
      };
      this.listeners.push(typeListener);
    }

    typeListener.listeners.push(listener);
  }

  public removeEventListener(type: string, listener: Listener) {}

  public dispatchEvent(event: Event) {
    const typeListener = this.listeners.find(
      (item) => item.type === event.type
    );
    if (!!typeListener) {
      typeListener.listeners.forEach((listener: Listener) => {
        listener.call(event.data);
      });
    }
  }
}

const dispatcher = new Dispatcher();
export { dispatcher };
